<dc-startup-heading></dc-startup-heading>

<dc-startup-features></dc-startup-features>
<dc-slider-bring-to-life></dc-slider-bring-to-life>
<dc-startup-why-dashcore></dc-startup-why-dashcore>
<dc-startup-videos></dc-startup-videos>
<dc-trust-us></dc-trust-us>
<dc-developer-designer></dc-developer-designer>
<dc-cta1 [edge]="'top-left'" [background]="'contrast'"></dc-cta1>

<dc-footer1></dc-footer1>
